// extracted by mini-css-extract-plugin
module.exports = {"holiday_icon":"HolidayIcon_holiday_icon__1_f_n","month":"HolidayIcon_month__3aqM3","inline":"HolidayIcon_inline__TXG_e"};